import { PropsWithoutRef } from "react";
import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import { SIDEBAR_WIDTH } from "../constants";
import PaymentsIcon from "@mui/icons-material/Payments";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import ReportIcon from "@mui/icons-material/Report";
import ForumIcon from "@mui/icons-material/Forum";
import CategoryIcon from "@mui/icons-material/Category";
import ArticleIcon from "@mui/icons-material/Article";
import NewspaperIcon from "@mui/icons-material/Newspaper";
interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    {
      label: "Dashboard",
      icon: <DashboardIcon />,
      key: "1",
      selected: "/dashboard",
    },
    {
      label: "Users",
      icon: <PeopleIcon />,
      key: "2",
      selected: "/manage-users",
    },
    {
      label: "Categories",
      icon: <CategoryIcon />,
      key: "3",
      selected: "/manage-categories",
    },
    {
      label: "Posts",
      icon: <ArticleIcon />,
      key: "8",
      selected: "/manage-posts",
    },
    {
      label: "Transactions",
      icon: <PaymentsIcon />,
      key: "4",
      selected: "/transactions",
    },
    {
      label: "Comments",
      icon: <ModeCommentIcon />,
      key: "5",
      selected: "/comments",
    },
    {
      label: "Reported",
      icon: <ReportIcon />,
      key: "6",
      selected: "/reported",
    },
    {
      label: "Coupon Code",
      icon: <ReportIcon />,
      key: "7",
      selected: "/couponcode",
    },
  ];

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 } }}
      className="sidebar-main-div"
    >
      <Drawer
        className="sidebar_drawer"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        <Toolbar
          className="sidebar-logo"
          sx={{ position: "relative", justifyContent: "flex-start" }}
        >
          <figure>
            <img
              src="/static/images/logo.png"
              alt=""
              onClick={() => navigate("/dashboard")}
            />
          </figure>
          <IconButton
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              color: "white",
              display: { lg: "none" },
            }}
            onClick={handleSidebarToggle}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        {items.map((item: any) => {
          const isSelected = location.pathname.includes(item?.selected);
          return (
            <List key={item?.label} className="sidebr-lst" sx={{ padding: 0 }}>
              <ListItemButton
                className={`lst-itm ${isSelected ? "Mui-selected" : ""}`}
                onClick={() => navigate(item?.selected)}
              >
                <ListItemIcon>{item?.icon}</ListItemIcon>
                <ListItemText className="lstitm-txt" primary={item?.label} />
              </ListItemButton>
            </List>
          );
        })}
        <p className="menu-heading">Discussion</p>
        <List className="sidebr-lst" sx={{ padding: 0 }}>
          <ListItemButton
            className={`lst-itm ${location?.pathname?.includes("forum-posts") ? "Mui-selected" : ""}`}
            onClick={() => navigate("/forum-posts")}
          >
            <ListItemIcon><ForumIcon /></ListItemIcon>
            <ListItemText className="lstitm-txt" primary={"Forum Posts"} />
          </ListItemButton>
        </List>
        <p className="menu-heading">Quick Updates</p>
        <List className="sidebr-lst" sx={{ padding: 0 }}>
          <ListItemButton
            className={`lst-itm ${location?.pathname?.includes("manage-news") ? "Mui-selected" : ""}`}
            onClick={() => navigate("/manage-news")}
          >
            <ListItemIcon><NewspaperIcon /></ListItemIcon>
            <ListItemText className="lstitm-txt" primary={"News"} />
          </ListItemButton>
        </List>
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        <Toolbar
          className="sidebar-logo"
          sx={{ position: "relative", justifyContent: "flex-start" }}
        >
          <figure>
            <img
              src="/static/images/logo.png"
              alt=""
              onClick={() => navigate("/dashboard")}
            />
          </figure>
          <IconButton
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              color: "white",
              display: { lg: "none" },
            }}
            onClick={handleSidebarToggle}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        {items.map((item: any) => {
          const isSelected = location.pathname.includes(item?.selected);
          return (
            <Link key={item?.label} to={item?.selected} style={{ textDecoration: "none" }}>
              <List className="sidebr-lst" sx={{ padding: 0 }}>
                <ListItemButton className={`lst-itm ${isSelected ? "Mui-selected" : ""}`}>
                  <ListItemIcon>{item?.icon}</ListItemIcon>
                  <ListItemText className="lstitm-txt" primary={item?.label} />
                </ListItemButton>
              </List>
            </Link>
          );
        })}
        <p className="menu-heading">Discussion</p>
        <Link to="/forum-posts" style={{ textDecoration: "none" }}>
          <List className="sidebr-lst" sx={{ padding: 0 }}>
            <ListItemButton
              className={`lst-itm ${location?.pathname?.includes("forum-posts") ? "Mui-selected" : ""}`}
            >
              <ListItemIcon><ForumIcon /></ListItemIcon>
              <ListItemText className="lstitm-txt" primary={"Forum Posts"} />
            </ListItemButton>
          </List>
        </Link>
        <p className="menu-heading">Quick Updates</p>
        <Link to="/manage-news" style={{ textDecoration: "none" }}>
          <List className="sidebr-lst" sx={{ padding: 0 }}>
            <ListItemButton
              className={`lst-itm ${location?.pathname?.includes("manage-news") ? "Mui-selected" : ""}`}
            >
              <ListItemIcon><NewspaperIcon /></ListItemIcon>
              <ListItemText className="lstitm-txt" primary={"News"} />
            </ListItemButton>
          </List>
        </Link>
      </Drawer>
    </Box>
  );
}
